import Stack from "@mui/material/Stack";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import KhattabatBulkMessages from "./bulk-messages/KhattabatBulkMessages";
import KhattabatClient from "./KhattabatClient";
import KhattabatSelects from "./selects/KhattabatSelects";
import KhattabatClientsHeader from "./header/KhattabatClientsHeader";
import getKhattabat101CGeneralStore from "../../../stores/khattabat-stores/101c-stores/101c-general-store";
import getKhattabatBulkMessagingStore from "../../../stores/khattabat-stores/messaging-stores/bulk-messaging-store";

const KhattabatClients = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { unitX } = theme;
  const clients = getKhattabat101CGeneralStore().getClients.get();
  getKhattabatBulkMessagingStore().initializeInputFields();

  return (
    <Stack
      spacing={2}
      sx={{ alignSelf: "stretch", pb: 2, pr: `${40 * unitX}px` }}
    >
      <KhattabatClientsHeader />
      <KhattabatSelects />
      <Stack>
        {clients.map((userID) => {
          return <KhattabatClient key={userID} userID={userID} />;
        })}
      </Stack>
      <KhattabatBulkMessages conversationType="101C" />
    </Stack>
  );
});
export default KhattabatClients;
